import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { UserIcon2 } from '../components/shared/Icons';
import {
  CasualsAvailabilityProvider,
  CasualsCreate,
  CasualsMine,
  CasualsJobs,
  CasualsCompleted,
  CasualsMessages,
} from './CasualsAvailability';
import { AvailableDaysBadge, PendingJobsBadge, DoneJobsBadge, CasualMessagesBellBadge } from './casualTabBadges';

const TABS = [
  { id: 'workavailablestaffd', label: 'Casual Availability' },
];

// One component per inner tab; they render with no props and read shared
// state (access, entries, jobs, message threads) from the provider below.
const AVAILABILITY_INNER = [
  { id: 'casualsavailabled', label: 'Create Availability', icon: <UserIcon2 />, component: CasualsCreate },
  // placeholder = the live count / bell after the label (InnerTabsd renders it inside the provider)
  { id: 'myavailabled',      label: 'My Availability',     icon: <UserIcon2 />, component: CasualsMine,      placeholder: AvailableDaysBadge },
  { id: 'assignedjobsd',     label: 'Assigned Jobs',       icon: <UserIcon2 />, component: CasualsJobs,      placeholder: PendingJobsBadge },
  { id: 'jobscompletedd',    label: 'Jobs Completed',      icon: <UserIcon2 />, component: CasualsCompleted, placeholder: DoneJobsBadge },
  { id: 'messagesd',         label: 'Messages',            icon: <UserIcon2 />, component: CasualsMessages,  placeholder: CasualMessagesBellBadge },
];

const FilterAvailablestaffd = () => {
  const [activeTab, setActiveTab] = useState('workavailablestaffd');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} homeRoute="/profile" homeColor={homeAccent} />
      <div className="fr-tab-content">
        {activeTab === 'workavailablestaffd' && (
          <CasualsAvailabilityProvider>
            <InnerTabsd tabs={AVAILABILITY_INNER} defaultId="casualsavailabled" />
          </CasualsAvailabilityProvider>
        )}
      </div>
    </div>
  );
};

export default FilterAvailablestaffd;